import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdCheck, MdClass, MdDetails, MdDownload, MdEmail, MdEventNote, MdFactCheck, MdHistory, MdInbox, MdInfo, MdLockReset, MdMail, MdMailOutline, MdMarkunreadMailbox, MdOutlineSettingsSuggest, MdPeople, MdSchool, MdSettings, MdSettingsAccessibility, MdStorage, MdTranslate } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { FaIconName, FaPersonBooth, FaUserGraduate } from 'react-icons/fa';
import ResearcherProfile from "../components/ResearcherProfile";
import { Dialog, DialogActions, DialogContent, Button } from "@mui/material";
import axios from "axios";
import { web_url } from "../../constant";

const url = "http://localhost:8080/api/";

const ROUND_BOUNDARIES = [
    { label: "Round 1 (up to 06 Sep 2026)", value: "1", start: null, end: new Date("2026-09-06T23:59:59") },
    { label: "Round 2 (07 Sep 2026 - Present)", value: "2", start: new Date("2026-09-07T00:00:00"), end: null },
];

function ResearcherDashboardDesktopPage() {
    // const channel = new BroadcastChannel("auth_channel");

    // useEffect(() => {
    //     const handleMessage = (event) => {
    //         if (event.data === "bridge_login_found") {
    //             // Step 1: Add a dummy history entry, then replace it to clear previous history
    //             window.history.pushState(null, "", "/");
    //             window.history.replaceState(null, "", "/");

    //             // Step 2: Redirect without creating a new history entry
    //             window.location.replace("/");
    //         }
    //     };

    //     channel.addEventListener("message", handleMessage);

    //     const handlePopState = () => {
    //         if (window.location.pathname === "/") {
    //             // Step 3: When back is pressed, push a new state and move forward
    //             window.history.pushState(null, "", "/");
    //             window.history.replaceState(null, "", "/");

    //             // Step 4: Move forward to prevent going back
    //             setTimeout(() => {
    //                 window.history.go(1);
    //             }, 50);

    //             // Step 5: Redirect the user outside the app
    //             window.location.replace("https://google.com");
    //         }
    //     };

    //     // Step 6: On page load, reset history so there’s nothing to go back to
    //     window.history.pushState(null, "", window.location.pathname);
    //     window.history.replaceState(null, "", window.location.pathname);

    //     window.addEventListener("popstate", handlePopState);

    //     return () => {
    //         channel.removeEventListener("message", handleMessage);
    //         window.removeEventListener("popstate", handlePopState);
    //     };
    // }, []);

    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);

    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };


    const [loadingValues, setLoadingValues] = useState(false);

    const [pendingEmails, setPEmails] = useState(0);
    const [translatedEmails, setTEmails] = useState(0);
    const [rejectedMails, setRMails] = useState(0);
    const [totalMessages, setTotalMessages] = useState("0");

    const [treatmentStudent, setTreatmentStudent] = useState(0)
    const [controlStudent, setControlStudent] = useState(0)
    const [studentsNumber, setStudentsNumber] = useState(0)
    const [teacherNumber, setTeacherNumber] = useState(0)
    const [translatorNumber, setTranslatorNumber] = useState(0)

    const [loadingTeacher, setLoadingTeacher] = useState(false);
    const [loadingControlStudent, setLoadingControlStudent] = useState(false);
    const [loadingTreatmentStudent, setLoadingTreatmentStudent] = useState(false);
    const [loadingStudent, setLoadingStudent] = useState(false);
    const [loadingTranslator, setLoadingTranslator] = useState(false);
    const [loadingTodayMails, setLoadingTodayMails] = useState(false);

    const [selectedRound, setSelectedRound] = useState("1");
    const [roundDownloadLoading, setRoundDownloadLoading] = useState(false);

    const getLogDetails = () => {
        return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
    };
    const logDetails = getLogDetails();

    const stripHtml = (html) =>
        (typeof html === "string" ? html : "").replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();

    const formatDT = (ts) => {
        if (!ts) return "—";
        return new Date(ts).toLocaleString("en-GB", { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" });
    };

    const getReceiver = (msg) => {
        const participants = msg.threadParticipants || msg.participants || [];
        const receiver = participants.find((p) => p !== msg.sender);
        return receiver || "—";
    };

    const getRoundLabel = () => {
        const round = ROUND_BOUNDARIES.find((r) => r.value === selectedRound);
        return round ? round.label.replace(/[^a-z0-9]/gi, "_").toLowerCase() : "round";
    };

    const fetchRoundLetters = async (roundVal, hdrs) => {
        const round = ROUND_BOUNDARIES.find((r) => r.value === roundVal);
        const params = new URLSearchParams();
        if (round?.start) params.append("startDate", round.start.toISOString());
        if (round?.end) params.append("endDate", round.end.toISOString());
        const qs = params.toString();
        const roundUrl = `${web_url}/api/email-threads/round-letters${qs ? `?${qs}` : ""}`;
        const res = await axios.get(roundUrl, hdrs);
        if (!Array.isArray(res.data)) throw new Error("Invalid export response");
        return res.data;
    };

    const downloadRoundExcel = async () => {
        const token = (JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails")))?.token;
        if (!token) return;
        setRoundDownloadLoading(true);
        const hdrs = { headers: { Authorization: `Bearer ${token}` } };
        try {
            const round = ROUND_BOUNDARIES.find((r) => r.value === selectedRound);
            const params = new URLSearchParams();
            if (round?.start) params.append("startDate", round.start.toISOString());
            if (round?.end) params.append("endDate", round.end.toISOString());
            const qs = params.toString();
            const excelUrl = `${web_url}/api/email-threads/round-letters/excel${qs ? `?${qs}` : ""}`;

            const res = await axios.get(excelUrl, { ...hdrs, responseType: "blob" });
            if (!res.data || res.data.size === 0) throw new Error("Empty export response");
            const objectUrl = window.URL.createObjectURL(res.data);
            const link = document.createElement("a");
            link.href = objectUrl;
            link.download = `letters_${getRoundLabel()}_${new Date().toISOString().slice(0, 10)}.xlsx`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);
        } catch (e) {
            window.alert("Unable to download Excel. Please try again.");
        } finally {
            setRoundDownloadLoading(false);
        }
    };

    const downloadRoundPdf = async () => {
        const token = (JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails")))?.token;
        if (!token) return;
        // Open synchronously while the click still grants popup permission.
        const printWindow = window.open("", "_blank");
        if (!printWindow) {
            window.alert("Please allow popups to download the PDF.");
            return;
        }
        printWindow.document.body.textContent = "Preparing letters…";
        setRoundDownloadLoading(true);
        const hdrs = { headers: { Authorization: `Bearer ${token}` } };
        try {
            const letters = await fetchRoundLetters(selectedRound, hdrs);
            if (!letters || letters.length === 0) {
                printWindow.close();
                window.alert("No letters found for this round.");
                return;
            }
            const roundLabelDisplay = ROUND_BOUNDARIES.find((r) => r.value === selectedRound)?.label || "All Letters";
            let bodyContent = "";
            letters.forEach((msg, i) => {
                const receiver = getReceiver(msg);
                const originalText = stripHtml(msg.body);
                const englishText = stripHtml(msg.englishBody);
                const translatedText = msg.translatedBody && msg.translatedBody !== "NA" ? stripHtml(msg.translatedBody) : "";
                const status = msg.moderationRecord?.action || (msg.moderationRecord === null ? "Pending" : "\u2014");
                const pb = i > 0 ? "page-break-before:always;" : "";
                bodyContent += "<div class=\"letter\" style=\"" + pb + "\">";
                bodyContent += "<h2 style=\"font-size:16px;color:#A07B00;margin-bottom:8px;border-bottom:2px solid #FDC50C;padding-bottom:6px;\">Letter " + (i + 1) + "</h2>";
                bodyContent += "<table style=\"font-size:12px;margin-bottom:12px;border-collapse:collapse;width:100%;\">";
                bodyContent += "<tr style=\"border-bottom:1px solid #eee;\"><td style=\"padding:6px 12px 6px 0;font-weight:bold;color:#555;width:200px;\">To:</td><td style=\"padding:6px 0;\">" + receiver + "</td></tr>";
                bodyContent += "<tr style=\"border-bottom:1px solid #eee;\"><td style=\"padding:6px 12px 6px 0;font-weight:bold;color:#555;\">From:</td><td style=\"padding:6px 0;\">" + (msg.sender || "\u2014") + "</td></tr>";
                bodyContent += "<tr style=\"border-bottom:1px solid #eee;\"><td style=\"padding:6px 12px 6px 0;font-weight:bold;color:#555;\">Date &amp; Time Sent:</td><td style=\"padding:6px 0;\">" + formatDT(msg.sentAt) + "</td></tr>";
                bodyContent += "<tr><td style=\"padding:6px 12px 6px 0;font-weight:bold;color:#555;\">Status:</td><td style=\"padding:6px 0;font-weight:600;color:#A07B00;\">" + status + "</td></tr></table>";
                if (originalText) bodyContent += "<div style=\"margin-top:14px;\"><p style=\"font-size:12px;font-weight:bold;color:#1A5276;margin-bottom:6px;border-left:3px solid #1A5276;padding-left:8px;\">Original Letter</p><div style=\"font-size:12px;background:#F4F8FC;border:1px solid #D6E4F0;border-radius:4px;padding:12px 16px;line-height:1.8;white-space:pre-wrap;\">" + originalText + "</div></div>";
                if (englishText) bodyContent += "<div style=\"margin-top:14px;\"><p style=\"font-size:12px;font-weight:bold;color:#217346;margin-bottom:6px;border-left:3px solid #217346;padding-left:8px;\">English Version</p><div style=\"font-size:12px;background:#F0FBF4;border:1px solid #B7DFC5;border-radius:4px;padding:12px 16px;line-height:1.8;white-space:pre-wrap;\">" + englishText + "</div></div>";
                if (translatedText) bodyContent += "<div style=\"margin-top:14px;\"><p style=\"font-size:12px;font-weight:bold;color:#856404;margin-bottom:6px;border-left:3px solid #856404;padding-left:8px;\">Translated Version</p><div style=\"font-size:12px;background:#FFFDF0;border:1px solid #FFEBAA;border-radius:4px;padding:12px 16px;line-height:1.8;white-space:pre-wrap;\">" + translatedText + "</div></div>";
                bodyContent += "</div>";
            });
            const fullHtml = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Letters — ${roundLabelDisplay}</title>
<style>@font-face{font-family:'Noto Sans Sinhala';src:url('${window.location.origin}${process.env.PUBLIC_URL || ""}/fonts/NotoSansSinhala-Regular.ttf')}@font-face{font-family:'Noto Sans Tamil';src:url('${window.location.origin}${process.env.PUBLIC_URL || ""}/fonts/NotoSansTamil-Regular.ttf')}
body{font-family:Arial,'Noto Sans Sinhala','Noto Sans Tamil',sans-serif;padding:20px;color:#333;}
.letter{page-break-inside:avoid;margin-bottom:30px;}</style></head><body>
<h1 style="font-size:22px;color:#A07B00;border-bottom:2px solid #FDC50C;padding-bottom:10px;">Letters — ${roundLabelDisplay}</h1>
<p style="font-size:13px;color:#666;">Total: ${letters.length} | Generated: ${new Date().toLocaleString()}</p>
<hr style="border:1px solid #eee;margin:20px 0;" />
${bodyContent}
<script>document.fonts.ready.then(function(){window.print();});<\/script>
</body></html>`;
            printWindow.document.open();
            printWindow.document.write(fullHtml);
            printWindow.document.close();
        } catch (e) {
            printWindow.close();
            window.alert("Unable to download PDF. Please try again.");
        } finally {
            setRoundDownloadLoading(false);
        }
    };

    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setLoadingControlStudent(true);
            const details = {
                accountStatus: "ACTIVE",
                penpalGroup: "CONTROL"
            };

            // const apiUrl = `${url}auth/students/filter`
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            axios.post(`${web_url}/api/auth/students/filter/number`, details, config)
                .then((response) => {
                    try {
                        const totalStudentsNumber = response.data;
                        setControlStudent(totalStudentsNumber);
                    } catch {
                        setControlStudent(0);
                    }

                    setLoadingControlStudent(false);
                })
                .catch((err) => {
                    console.log("error occured");
                    setLoadingControlStudent(false);
                });
        }
    }, [])

    //treat stu
    useEffect(() => {

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setLoadingTreatmentStudent(true);
            const details = {
                accountStatus: "ACTIVE",
                penpalGroup: "TREATMENT"
            };

            // const apiUrl = `${url}auth/students/filter`
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            // axios.post(apiUrl, researcher, config)
            axios.post(`${web_url}/api/auth/students/filter/number`, details, config)
                .then((response) => {
                    try {
                        const totalStudentsNumber = response.data;
                        setTreatmentStudent(totalStudentsNumber);
                    } catch {
                        setTreatmentStudent(0);
                    }

                    setLoadingTreatmentStudent(false);
                })
                .catch((err) => {
                    console.log("error occured");
                    setLoadingTreatmentStudent(false);
                });
        }
    }, [])

    //total active stu
    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setLoadingStudent(true);
            const details = {
                accountStatus: "ACTIVE",
            };

            // const apiUrl = `${url}auth/students/filter`
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            // axios.post(apiUrl, researcher, config)
            axios.post(`${web_url}/api/auth/students/filter/number`, details, config)
                .then((response) => {
                    try {
                        const totalStudentsNumber = response.data;
                        setStudentsNumber(totalStudentsNumber);
                    } catch {
                        setStudentsNumber(0);
                    }

                    setLoadingStudent(false);
                })
                .catch((err) => {
                    console.log("error occured");
                    setLoadingStudent(false);
                });
        }
    }, [])

    //teacher
    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setLoadingTeacher(true);

            const apiUrl = `${web_url}/api/auth/teachers`

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            // axios.post(apiUrl, researcher, config)
            axios.get(apiUrl, configToken)
                .then((response) => {
                    try {
                        const totalTeacherNumber = response.data.length;
                        setTeacherNumber(totalTeacherNumber);
                    } catch {
                        setTeacherNumber(0);
                    }

                    setLoadingTeacher(false);
                })
                .catch((err) => {
                    console.log("error occured");
                    setLoadingTeacher(false);
                });
        }
    }, [])

    //translator
    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setLoadingTranslator(true);

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            const apiUrl = `${web_url}/api/auth/translators`

            axios.get(apiUrl, configToken)
                .then((response) => {
                    try {
                        const totalTranslatorNumber = response.data.length;
                        setTranslatorNumber(totalTranslatorNumber);
                    } catch {
                        setTranslatorNumber(0);
                    }

                    setLoadingTranslator(false);
                })
                .catch((err) => {
                    console.log("error occured");
                    setLoadingTranslator(false);
                });
        }
    }, [])

    //total emails today
    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setLoadingTodayMails(true);

            const apiUrl = `${web_url}/api/email-threads/emails-sent-today`

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            axios.get(apiUrl, configToken)
                .then((response) => {
                    try {
                        const totalMails = response.data.message;
                        setTotalMessages(totalMails);
                    } catch {
                        setTotalMessages("0");
                    }

                    setLoadingTodayMails(false);
                })
                .catch((err) => {
                    console.log("error occured");
                    setLoadingTodayMails(false);
                });
        }
    }, [])



    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setLoadingValues(true);

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            axios.get(`${web_url}/api/email-threads/moderator-counts`, configToken)
                .then((response) => {
                    setPEmails(response.data?.pending || 0);
                    setTEmails(response.data?.approved || 0);
                    setRMails(response.data?.rejected || 0);
                    setLoadingValues(false);
                })
                .catch((err) => {
                    setPEmails(0);
                    setTEmails(0);
                    setRMails(0);
                    setLoadingValues(false);
                });
        }

    }, [])

    const [loadingPage, setLoadingPage] = useState(false);
    const [researcherName, setResearcherName] = useState('');

    useEffect(() => {
        if (sessionStorage.getItem('greetings')) {
            const greetings = sessionStorage.getItem("greetings");
            if (greetings === 'true') {
                setLoadingPage(true);
                const getLogDetails = () => {
                    return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                };
                const logDetails = getLogDetails();

                const configToken = {
                    headers: {
                        'Authorization': `Bearer ${logDetails.token}`,
                    },
                };

                axios.get(`${web_url}/api/auth/researchers`, configToken).then((resR) => {
                    const resMain = resR.data[0].userEmail;
                    localStorage.setItem('resMain', resMain);
                    const apiUrl = `${web_url}/api/auth/researchers/${logDetails.email}`
                    axios.get(apiUrl, configToken)
                        .then((response) => {
                            // console.log(response.data);
                            localStorage.setItem('name', response.data.userFullName);
                            localStorage.setItem('mobile', response.data.contactNumber);
                            setResearcherName(response.data.userFullName);
                            setLoadingPage(false);
                            setOpen(true);
                            sessionStorage.removeItem('greetings');
                        })
                        .catch((err) => {
                            console.log("error occured");
                        });
                }).catch((errR) => {
                    console.log("error occured");
                })
            }

        } else {
            setResearcherName(localStorage.getItem('name'));
        }
    }, [])

    const [isOverViewSelected, setIsOverViewSelected] = useState(true);

    useEffect(() => {
        if (loadingPage) {
            setOpen2(true);
        } else {
            setOpen2(false);
        }
    }, [loadingPage])

    const [open2, setOpen2] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 1270) {
                navigate('/mobile/researcher/greeting')
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // useEffect(() => {
    //     const getLogDetails = () => {
    //         return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
    //     };
    //     const logDetails = getLogDetails();
    //     const currentTime = new Date();
    //     if (!logDetails) {
    //         alert("Please re-sign up to continue");
    //         localStorage.clear();
    //         sessionStorage.clear();
    //         navigate('/loginas')
    //     } else {
    //         if (sessionStorage.getItem('exp')) {
    //             if (new Date(sessionStorage.getItem('exp')) < currentTime) {
    //                 alert("Please re-sign up to continue");
    //                 localStorage.clear();
    //                 sessionStorage.clear();
    //                 navigate('/loginas')
    //             } else if (sessionStorage.getItem('exp') !== logDetails.exp) {
    //                 alert("Please re-sign up to continue");
    //                 // localStorage.clear();
    //                 sessionStorage.clear();
    //                 navigate('/loginas')
    //             }
    //         } else {
    //             sessionStorage.setItem('exp', logDetails.exp)
    //             if (new Date(logDetails.exp) < currentTime) {
    //                 alert("Please re-sign up to continue");
    //                 localStorage.clear();
    //                 sessionStorage.clear();
    //                 navigate('/loginas')
    //             }
    //         }
    //     }
    // }, []);


    useEffect(() => {

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };

        const checkAuth = () => {
            const logDetails = getLogDetails();
            const currentTime = new Date();

            if (!logDetails) {
                alert("Please re-sign up to continue");
                localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            } else if (logDetails.category.toLowerCase() !== "researcher") {
                alert("Please re-sign up to continue");
                // localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            }

            if (sessionStorage.getItem('exp')) {
                if (new Date(sessionStorage.getItem('exp')) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                } else if (sessionStorage.getItem('exp') !== logDetails.exp) {
                    alert("Please re-sign up to continue");
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            } else {
                sessionStorage.setItem('exp', logDetails.exp);
                if (new Date(logDetails.exp) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            }
        };

        checkAuth(); // Run on mount

        const handleStorageChange = (event) => {
            if (event.key === "logDetails") {
                checkAuth(); // Re-check authentication if storage changes
            }
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);




    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-bgImg md:bg-bglarge bg-repeat bg-cover min-h-screen w-screen xl:pt-[50px]`}>
            <div className="xl:hidden absolute top-0 left-0 py-[25px] pl-[20px] md:pl-[30px] lg:pl-[40px]">
                <div className="flex justify-center items-center" >
                    <img className="h-[50px] md:h-[70px] lg:h-[90px]" src="/images/logo.svg" alt="logo" />
                    <p className="ml-[10px]  font-semibold text-[16px] md:text-[20px] lg:text-[25px]">{t('t1')}</p>
                </div>
            </div>
            <div className="rounded-md hidden xl:grid grid-cols-3 py-[5px] 2xl:py-[10px] bg-gradient-to-r from-[#FFA803] to-[#FFD12E] mx-[70px] px-[20px]">
                <div className="flex justify-start items-center">
                    <img className="h-[40px]" src="/images/logo.svg" alt="logo" />
                    <p className="ml-[10px] font-semibold text-[20px]">{t('t1')}</p>
                </div>
                <div className="grid grid-cols-3 w-full">
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/home-w.svg" alt="home" onClick={() => navigate('/desktop/researcher/dashboard')} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t410')}
                        </span>
                    </div>
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/mail-b.svg" alt="mail" onClick={() => {
                            const mailRequest = {
                                type: 'new',
                                subject: 'nothing'
                            };
                            localStorage.setItem('threadId', JSON.stringify(mailRequest));
                            navigate('/desktop/researcher/mailbox')

                        }} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t411')}
                        </span>
                    </div>
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/settings-b.svg" alt="settings" onClick={() => navigate('/desktop/researcher/settings')} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t153')}
                        </span>
                    </div>
                </div>
                <div className="flex justify-end items-center">
                    <Menu as="div" className="text-left items-right">
                        <div>
                            <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 lg:py-3 text-sm md:text-[17px] md:text-[21px] font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                                {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                                <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 md:size-6 text-gray-400" />
                            </MenuButton>
                        </div>

                        <MenuItems
                            transition
                            className="absolute right-0 z-10 mt-2 w-[200px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                        >
                            <div className="py-1">
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("English");
                                            changeLanguage('en')
                                        }}
                                    >
                                        English
                                    </button>
                                </MenuItem>
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("Sinhala");
                                            changeLanguage('si')
                                        }}
                                    >
                                        සිංහල
                                    </button>
                                </MenuItem>
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("Tamil");
                                            changeLanguage('ta')
                                        }}
                                    >
                                        தமிழ்
                                    </button>
                                </MenuItem>
                            </div>
                        </MenuItems>
                    </Menu>
                </div>
            </div>
            <div className="grid grid-cols-5 w-full">
                <div className="col-span-3">
                    <div className="flex justify-center gap-[15px] md:gap-[30px] items-center pt-[100px] md:pt-[130px] lg:pt-[150px] xl:pt-[30px] w-full">
                        <div onClick={() => setIsOverViewSelected(true)} className={`${isOverViewSelected ? 'bg-[#FDC50C]' : 'bg-[#D9D9D9]'} rounded-2xl xl:ml-[80px] ${i18n.language === "si" ? "w-[200px]" : "w-[180px]"} flex justify-center cursor-pointer`}>
                            <p className={`${i18n.language === "en" ? "xl:text-[20px] 2xl:text-[22px]" : "xl:text-[17px] 2xl:text-[18px]"} font-bold px-[10px] py-[5px] md:px-[13px] md:py-[8px]`}>{t('t104')}</p>
                        </div>
                        <div onClick={() => setIsOverViewSelected(false)} className={`${!isOverViewSelected ? 'bg-[#FDC50C]' : 'bg-[#D9D9D9]'} rounded-2xl xl:ml-[80px] ${i18n.language === "si" ? "w-[200px]" : "w-[180px]"} flex justify-center cursor-pointer`}>
                            <p className={`${i18n.language === "en" ? "xl:text-[20px] 2xl:text-[22px]" : "xl:text-[17px] 2xl:text-[18px]"} font-bold px-[10px] py-[5px] md:px-[13px] md:py-[8px]`}>{t('t181')}</p>
                        </div>
                    </div>
                    {
                        isOverViewSelected ?
                            <div className="grid grid-cols-3 mt-[20px] xl:ml-[80px] xl:mr-[20px]">
                                <div className="flex flex-col justify-center items-center mr-[10px] lg:mr-[20px] xl:mr-[30px]">
                                    <div className="bg-[#D1B9F2] w-full flex justify-center rounded-t-xl items-center h-[60px]">
                                        <p className="text-[#705597] text-[15px] md:text-[16px] lg:text-[18px] xl:text-[17px] xl:text-[17px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px]">{t('t182')}</p>
                                    </div>
                                    <div className="bg-[#EADCFE] w-full flex justify-center rounded-b-xl">
                                        {
                                            loadingTreatmentStudent ?
                                                <div className="items-center justify-center flex p-3">
                                                    <div className='w-7 h-7 border-2 border-t-transparent border-[#705597] rounded-full animate-spin'></div>
                                                </div>
                                                :
                                                <p className="text-[#705597] font-bold text-[40px] px-[20px] py-[10px]">{treatmentStudent}</p>
                                        }
                                    </div>
                                </div>
                                <div className="flex flex-col justify-center items-center mr-[10px] lg:mr-[20px] xl:mr-[30px]">
                                    <div className="bg-[#CDE99A] w-full flex justify-center rounded-t-xl items-center h-[60px]">
                                        <p className="text-[#698633] text-[15px] md:text-[16px] lg:text-[18px] xl:text-[17px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px]">{t('t183')}</p>
                                    </div>
                                    <div className="bg-[#EFFADB] w-full flex justify-center rounded-b-xl">
                                        {
                                            loadingControlStudent ?
                                                <div className="items-center justify-center flex p-3">
                                                    <div className='w-7 h-7 border-2 border-t-transparent border-[#698633] rounded-full animate-spin'></div>
                                                </div>
                                                :
                                                <p className="text-[#698633] font-bold text-[40px] px-[20px] py-[10px]">{controlStudent}</p>
                                        }
                                    </div>
                                </div>
                                <div className="flex flex-col justify-center items-center mr-[10px] lg:mr-[20px] xl:mr-[30px]">
                                    <div className="bg-[#A1E0BB] w-full flex justify-center rounded-t-xl items-center h-[60px]">
                                        <p className="text-[#336C4B] text-[15px] md:text-[16px] lg:text-[18px] xl:text-[17px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px]">{t('t184')}</p>
                                    </div>
                                    <div className="bg-[#DBFAE8] w-full flex justify-center rounded-b-xl">
                                        {
                                            loadingTeacher ?
                                                <div className="items-center justify-center flex p-3">
                                                    <div className='w-7 h-7 border-2 border-t-transparent border-[#336C4B] rounded-full animate-spin'></div>
                                                </div>
                                                :
                                                <p className="text-[#336C4B] font-bold text-[40px] px-[20px] py-[10px]">{teacherNumber}</p>
                                        }
                                    </div>
                                </div>
                                <div className="mt-[10px] 2xl:mt-[20px] flex flex-col justify-center items-center mr-[10px] lg:mr-[20px] xl:mr-[30px]">
                                    <div className="bg-[#DDC69D] w-full flex justify-center rounded-t-xl items-center h-[60px]">
                                        <p className="text-[#695531] text-[15px] md:text-[16px] lg:text-[18px] xl:text-[17px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px]">{t('t185')}</p>
                                    </div>
                                    <div className="bg-[#FEF2DC] w-full flex justify-center rounded-b-xl">
                                        {
                                            loadingTranslator ?
                                                <div className="items-center justify-center flex p-3">
                                                    <div className='w-7 h-7 border-2 border-t-transparent border-[#695531] rounded-full animate-spin'></div>
                                                </div>
                                                :
                                                <p className="text-[#695531] font-bold text-[40px] px-[20px] py-[10px]">{translatorNumber}</p>
                                        }
                                    </div>
                                </div>
                                <div className="mt-[10px] 2xl:mt-[20px] flex flex-col justify-center items-center mr-[10px] lg:mr-[20px] xl:mr-[30px]">
                                    <div className="bg-[#A1E0BB] w-full flex justify-center rounded-t-xl items-center h-[60px]">
                                        <p className="text-center text-[#336C4B] text-[15px] md:text-[16px] lg:text-[18px] xl:text-[17px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px] xl:px-[10px] xl:py-[15px]">{t('t415')}</p>
                                    </div>
                                    <div className="bg-[#DBFAE8] w-full flex justify-center rounded-b-xl">
                                        {
                                            loadingStudent ?
                                                <div className="items-center justify-center flex p-3">
                                                    <div className='w-7 h-7 border-2 border-t-transparent border-[#336C4B] rounded-full animate-spin'></div>
                                                </div>
                                                :
                                                <p className="text-[#336C4B] font-bold text-[40px] px-[20px] py-[10px]">{studentsNumber}</p>
                                        }
                                    </div>
                                </div>
                                <div className="mt-[10px] 2xl:mt-[20px] flex flex-col justify-center items-center mr-[10px] lg:mr-[20px] xl:mr-[30px]">
                                    <div className="bg-[#E2C565] w-full flex justify-center items-center rounded-t-xl h-[60px]">
                                        <p className="text-[#7A5E00] text-[15px] md:text-[16px] lg:text-[18px] xl:text-[17px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px]">{t('t187')}</p>
                                    </div>
                                    <div className="bg-[#FFEBA9] w-full flex justify-center rounded-b-xl">
                                        {
                                            loadingTodayMails ?
                                                <div className="items-center justify-center flex p-3">
                                                    <div className='w-7 h-7 border-2 border-t-transparent border-[#7A5E00] rounded-full animate-spin'></div>
                                                </div>
                                                :
                                                <p className="text-[#7A5E00] font-bold text-[40px] px-[20px] py-[10px]">{totalMessages}</p>
                                        }
                                    </div>
                                </div>
                            </div> :
                            <div className="grid grid-cols-3 mt-[20px] xl:ml-[80px] xl:mr-[20px]">
                                <div className="flex flex-col justify-center items-center mr-[10px] lg:mr-[20px] xl:mr-[30px]">
                                    <div className="bg-[#D1B9F2] w-full flex justify-center rounded-t-xl items-center h-[60px]">
                                        <p className="text-center text-[#705597] text-[15px] md:text-[16px] lg:text-[18px] xl:text-[17px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px]">{t('t188')}</p>
                                    </div>
                                    <div className="bg-[#EADCFE] w-full flex justify-center rounded-b-xl">
                                        {
                                            loadingValues ?
                                                <div className="items-center justify-center flex p-3">
                                                    <div className='w-7 h-7 border-2 border-t-transparent border-[#705597] rounded-full animate-spin'></div>
                                                </div>
                                                :
                                                <p className="text-[#705597] font-bold text-[40px] px-[20px] py-[10px]">{translatedEmails}</p>
                                        }
                                    </div>
                                </div>
                                <div className="flex flex-col justify-center items-center mr-[10px] lg:mr-[20px] xl:mr-[30px] cursor-pointer" onClick={() => navigate('/researcher/rejected-letters')}>
                                    <div className="bg-[#CDE99A] w-full flex justify-center rounded-t-xl items-center h-[60px] hover:bg-[#b8d980] transition-colors">
                                        <p className="text-[#698633] text-[15px] md:text-[16px] lg:text-[18px] xl:text-[16px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px]">{t('t189')}</p>
                                    </div>
                                    <div className="bg-[#EFFADB] w-full flex justify-center rounded-b-xl hover:bg-[#ddf5b8] transition-colors">
                                        {
                                            loadingValues ?
                                                <div className="items-center justify-center flex p-3">
                                                    <div className='w-7 h-7 border-2 border-t-transparent border-[#698633] rounded-full animate-spin'></div>
                                                </div>
                                                :
                                                <p className="text-[#698633] font-bold text-[40px] px-[20px] py-[10px]">{rejectedMails}</p>
                                        }
                                    </div>
                                </div>
                                <div className="flex flex-col justify-center items-center mr-[10px] lg:mr-[20px] xl:mr-[30px] cursor-pointer" onClick={() => navigate('/researcher/pending-letters')}>
                                    <div className="bg-[#A1E0BB] w-full flex justify-center rounded-t-xl items-center h-[60px] hover:bg-[#8fd4ab] transition-colors">
                                        <p className="text-center text-[#336C4B] text-[15px] md:text-[16px] lg:text-[18px] xl:text-[16px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px]">{t('t190')}</p>
                                    </div>
                                    <div className="bg-[#DBFAE8] w-full flex justify-center rounded-b-xl hover:bg-[#cbf7dd] transition-colors">
                                        {
                                            loadingValues ?
                                                <div className="items-center justify-center flex p-3">
                                                    <div className='w-7 h-7 border-2 border-t-transparent border-[#336C4B] rounded-full animate-spin'></div>
                                                </div>
                                                :
                                                <p className="text-[#336C4B] font-bold text-[40px] px-[20px] py-[10px]">{pendingEmails}</p>
                                        }
                                    </div>
                                </div>
                            </div>
                    }

                    <div className="hidden xl:grid grid-cols-3 xl:gap-[10px] mt-[30px] 2xl:mt-[50px] ml-[80px]">
                        <div className={`flex justify-center items-center mr-[20px] cursor-pointer  ${i18n.language === "ta" ? "h-[80px]" : "h-[70px]"} `} onClick={() => navigate('/researcher/managedata')}>
                            <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center">
                                <MdStorage size={30} color="#FDC50C" />
                            </div>
                            <div className="bg-[#FFEBA9] py-[22px] 2xl:py-[20px] pl-[10px] pr-[8px] w-full rounded-r-lg h-full flex items-center">
                                <p className={`overflow-hidden text-ellipsis  text-black ${i18n.language === "si" ? "text-[14px] 2xl:text-[16px]" : (i18n.language === "en" ? "text-[18px] 2xl:text-[18px]" : "text-[16px] 2xl:text-[18px]")} font-bold`}>{t('t191')}</p>
                            </div>
                        </div>
                        <div className={`flex justify-center items-center mr-[20px] cursor-pointer  ${i18n.language === "ta" ? "h-[80px]" : "h-[70px]"} `} onClick={() => navigate('/sendinvitation')}>
                            <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center">
                                <MdMailOutline size={30} color="#FDC50C" />
                            </div>
                            <div className="bg-[#FFEBA9] py-[22px] 2xl:py-[20px] pl-[10px] pr-[8px] w-full rounded-r-lg h-full flex items-center">
                                <p className={`overflow-hidden text-ellipsis  text-black ${i18n.language === "si" ? "text-[14px] 2xl:text-[16px]" : (i18n.language === "en" ? "text-[18px] 2xl:text-[18px]" : "text-[16px] 2xl:text-[18px]")} font-bold`}>{t('t192')}</p>
                            </div>
                        </div>
                        <div className={`flex justify-center items-center mr-[20px] cursor-pointer  ${i18n.language === "ta" ? "h-[80px]" : "h-[70px]"} `} onClick={() => navigate('/researcher/penpalmatching')}>
                            <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center">
                                <MdPeople size={30} color="#FDC50C" />
                            </div>
                            <div className="bg-[#FFEBA9] py-[22px] 2xl:py-[20px] pl-[10px] pr-[8px] w-full rounded-r-lg h-full flex items-center">
                                <p className={`overflow-hidden text-ellipsis  text-black ${i18n.language === "si" ? "text-[14px] 2xl:text-[16px]" : (i18n.language === "en" ? "text-[18px] 2xl:text-[18px]" : "text-[16px] 2xl:text-[18px]")} font-bold`}>{t('t193')}</p>
                            </div>
                        </div>
                        <div className={`mt-[20px] flex justify-center items-center mr-[20px] cursor-pointer  ${i18n.language === "ta" ? "h-[80px]" : "h-[70px]"} `} onClick={() => navigate('/researcher/resetpassword')}>
                            <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center">
                                <MdLockReset size={30} color="#FDC50C" />
                            </div>
                            <div className="bg-[#FFEBA9] py-[22px] 2xl:py-[20px] pl-[10px] pr-[8px] w-full rounded-r-lg h-full flex items-center">
                                <p className={`overflow-hidden text-ellipsis  text-black ${i18n.language === "si" ? "text-[14px] 2xl:text-[16px]" : (i18n.language === "en" ? "text-[18px] 2xl:text-[18px]" : "text-[16px] 2xl:text-[18px]")} font-bold`}>{t('t194')}</p>
                            </div>
                        </div>
                        <div className={`mt-[20px] flex justify-center items-center mr-[20px] cursor-pointer  ${i18n.language === "ta" ? "h-[80px]" : "h-[70px]"} `} onClick={() => navigate('/researcher/data/download')}>
                            <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center">
                                <MdDownload size={30} color="#FDC50C" />
                            </div>
                            <div className="bg-[#FFEBA9] py-[22px] 2xl:py-[20px] pl-[10px] pr-[8px] w-full rounded-r-lg h-full flex items-center">
                                <p className={`overflow-hidden text-ellipsis  text-black ${i18n.language === "si" ? "text-[14px] 2xl:text-[16px]" : (i18n.language === "en" ? "text-[18px] 2xl:text-[18px]" : "text-[16px] 2xl:text-[18px]")} font-bold`}>{t('t195_2')}</p>
                            </div>
                        </div>
                        <div className={`mt-[20px] flex justify-center items-center mr-[20px] cursor-pointer  ${i18n.language === "ta" ? "h-[80px]" : "h-[70px]"}`} onClick={() => {
                            if (logDetails?.email === "admin@gmail.com") {
                                navigate('/researcher/accounts/select');
                            } else {
                                navigate('/researcher/translator/list')
                            }

                        }}>
                            <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center">
                                <MdInfo size={30} color="#FDC50C" />
                            </div>
                            <div className="bg-[#FFEBA9] py-[22px] 2xl:py-[20px] pl-[10px] pr-[8px] w-full rounded-r-lg h-full flex items-center">
                                <p className={`overflow-hidden text-ellipsis  text-black ${i18n.language === "si" ? ((logDetails?.email === "admin@gmail.com") ? "xl:text-[14px] 2xl:text-[16px]" : "xl:text-[13px] 2xl:text-[16px]") : (i18n.language === "ta" ? ((logDetails?.email === "admin@gmail.com") ? "xl:text-[14px] 2xl:text-[16px]" : "xl:text-[13px] 2xl:text-[12px]") : ((logDetails?.email === "admin@gmail.com") ? "xl:text-[16px] 2xl:text-[18px]" : "xl:text-[16px] 2xl:text-[18px]"))}  font-bold`}>{logDetails?.email === "admin@gmail.com" ? t('t424') : t('t421')}</p>
                            </div>
                        </div>
                        <div className={`mt-[20px] flex justify-center items-center mr-[20px] cursor-pointer  ${i18n.language === "ta" ? "h-[80px]" : "h-[70px]"}`} onClick={() => navigate('/researcher/school-letter-report')}>
                            <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center">
                                <MdSchool size={30} color="#FDC50C" />
                            </div>
                            <div className="bg-[#FFEBA9] py-[22px] 2xl:py-[20px] pl-[10px] pr-[8px] w-full rounded-r-lg h-full flex items-center">
                                <p className="overflow-hidden text-ellipsis text-black xl:text-[16px] 2xl:text-[18px] font-bold">School Letter Report</p>
                            </div>
                        </div>
                    </div>

                    <div className="hidden xl:block mt-[30px] 2xl:mt-[50px] mb-[60px] 2xl:mb-[80px] ml-[80px] mr-[20px]">
                        <div className="bg-gradient-to-br from-[#FFF6DA] to-[#FFEBA9] border border-[#E2C565] rounded-2xl px-[24px] py-[20px] shadow-sm">
                            <p className="text-[15px] 2xl:text-[17px] font-bold text-[#7A5E00] mb-[14px]">Download Letters by Round</p>
                            <div className="flex items-center gap-[14px] flex-wrap">
                                <select
                                    id="dashboard-round-select"
                                    value={selectedRound}
                                    onChange={(e) => setSelectedRound(e.target.value)}
                                    className="border border-[#E2C565] bg-white text-gray-700 text-[13px] 2xl:text-[14px] rounded-lg py-[8px] px-[12px] focus:outline-none focus:ring-2 focus:ring-[#A07B00] cursor-pointer min-w-[220px]"
                                >
                                    {ROUND_BOUNDARIES.map((r) => (
                                        <option key={r.value} value={r.value}>{r.label}</option>
                                    ))}
                                </select>
                                <button
                                    id="dashboard-round-excel-btn"
                                    disabled={roundDownloadLoading}
                                    onClick={downloadRoundExcel}
                                    className="flex items-center gap-[8px] bg-[#217346] text-white rounded-lg text-[13px] 2xl:text-[14px] py-[8px] px-[16px] hover:bg-opacity-90 disabled:opacity-50 font-semibold"
                                >
                                    <MdDownload size={18} />
                                    {roundDownloadLoading ? "Downloading..." : "Download Excel"}
                                </button>
                                <button
                                    id="dashboard-round-pdf-btn"
                                    disabled={roundDownloadLoading}
                                    onClick={downloadRoundPdf}
                                    className="flex items-center gap-[8px] bg-[#A07B00] text-white rounded-lg text-[13px] 2xl:text-[14px] py-[8px] px-[16px] hover:bg-opacity-90 disabled:opacity-50 font-semibold"
                                >
                                    <MdDownload size={18} />
                                    {roundDownloadLoading ? "Downloading..." : "Download PDF"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-span-2">
                    <ResearcherProfile t={t} />
                </div>
            </div>
            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className="flex flex-col justify-center items-center">
                            <p className="font-bold text-[15px] 2xl:text-[18px]">{t('t79')} {researcherName}</p>
                            <p className="pt-[20px] text-[15px] 2xl:text-[18px]">{t('t196')}</p>
                        </div>
                    </DialogContent>

                </DialogContent>
                <DialogActions
                    style={{
                        backgroundColor: '#FFF6DA',
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                    }}
                >
                    <Button
                        disabled={loadingPage}
                        onClick={() => {
                            setOpen(false);
                        }}
                        style={{
                            margin: '0px 0px 10px 0px',
                            backgroundColor: '#F2AC0E',
                            color: 'white',
                            padding: '10px 20px', // px-4 py-2
                            borderRadius: '0.375rem', // rounded-md
                            fontWeight: 'bold',
                        }}
                    >
                        {t('t7')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open2}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className="items-center justify-center flex">
                            <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                        </div>
                    </DialogContent>

                </DialogContent>
            </Dialog>
        </div>
    )
}

export default ResearcherDashboardDesktopPage;
